import FieldSet from '../../FieldSet';

import { CapacityTeamTags } from './CapacityTeamTags';

export class CapacityTeamFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [CapacityTeamTags];
  }

  get title() {
    return 'Capacity planning teams';
  }
}
